<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="classIdPro"
            :search-url="searchUrl"
            create-url=""
            delete-url=""
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            custom-edit-item
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="false"
            :acceptView="false"
            :accept-create="false"
            @viewItem="viewItem"
            :accept-back="10"
        >
        </c-search-form>
        <!--            search-url="/kidClass/search/?sortField=status,classId&"-->
        <material-type-group-create
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        />
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../components/form/ManageForm";
import {areaContants, cateContants} from "@/constants";
import axios from "axios";
import MaterialTypeGroupCreate from "@/views/babiPro/ClassBabiProCreate";
import {classIsActive, levelBabiPro} from "@/constants/cateContants";

export default {
  name: "warehouse",
  components: {MaterialTypeGroupCreate, CSearchForm},
  data: () => {
    return {
      formName: "Thông tin lịch học của lớp",
      formCreateName: "",
      category: null,
      lastSearchValues: {},
      searchUrl: null,
      visibleCreateDialog: false,
      timeReload: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'className',
          text: 'Tên lớp',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center"
        },
        {
          value: 'nameTeacher',
          text: 'Giáo viên dạy',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center"
        },
        {
          value: 'nameTeacherTa',
          text: 'Giáo viên Ta',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center"
        },
        {
          value: 'learDateStr',
          text: 'Ngày học',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center"
        },
        {
          value: 'programTimeName',
          text: 'Khung thời gian',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center"
        },
        {
          value: 'scheduleNumber',
          text: 'Buổi học số',
          sortable: false,
          search: false,
          width: "10%",
          headerStyle: "text-align:center"
        }
      ],
    };
  },

  created() {
    this.searchUrl ="/kidSchedule/search/" + this.$route.params.id + "?sortField=status,classId&";
    axios.post(
        process.env.VUE_APP_API_URL + "/kidProgramTime/listAllName", {isActive: 1}
    )
        .then(
            (data) => {
              console.info(data)
              let itemFields = this.fields.filter(function (e) {
                return e.name == "programTimeId";
              });

              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );

    axios.post(
        process.env.VUE_APP_API_URL + "/kidPackage/listAllName", {isActive: 1}
    )
        .then(
            (data) => {
              console.info(data)
              let itemFields = this.fields.filter(function (e) {
                return e.name == "packageId";
              });

              if (itemFields != undefined && itemFields.length > 0) {
                itemFields[0].items = data;
              }
            }
        );
  },

  methods: {
    clearFromDate() {
      this.hiddenFields.fromDate = null;
    },
    clearToDate() {
      this.hiddenFields.toDate = null;
    },
    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới lớp học Babi Pro';
        this.getNextCode();
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật lớp học Babi Pro';
        this.visibleCreateDialog = true;
      }
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },

    getNextCode: function () {
      axios.get(
          process.env.VUE_APP_API_URL +
          "/autoIncrease/getNextNumber?type=MATERIAL_TYPE_ALLY"
      )
          .then((data) => {
            this.category = Object.assign({}, this.category, {"categoryCode": "MATERIAL_TYPE_ALLY" + data, "status": 1})
            this.visibleCreateDialog = true;
          });
    },
    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
    viewItem: function (item) {
      this.$router.push({
        path: '/classPro/view/' + item.classIdPro, query: this.createParamLastSearch(this.lastSearchValues)
      });
    },
  },

  destroyed() {
  },
};
</script>
